import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=dd8c5834&scoped=true"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=dd8c5834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c5834",
  null
  
)

export default component.exports